import * as React from 'react';
import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import LiveHelpRoundedIcon from '@material-ui/icons/LiveHelpRounded';
import ScrollToBottom from 'react-scroll-to-bottom';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Files from 'react-files';
import { GetSupportMessage } from 'src/reducers/supportPage';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TelegramIcon from '@material-ui/icons/Telegram';
import PostAddOutlinedIcon from '@material-ui/icons/PostAddOutlined';
import IconButton from '@material-ui/core/IconButton';
import Previewform from './PreviewForm';
import DeleteIcon from '@material-ui/icons/Delete';

export interface SupportPageprops {
    getSupportMessage: GetSupportMessage[];
    customer: string;
    messaging: (message: string) => void;
    messages: string;
    onSubmit: () => void;
    goToFeedback: () => void;
    onFilesChange: (messageFiles: Array<File>) => void;
    onFilesError: (error: Error, images: Array<File>) => void;
    msgAtt: (msgAttachment: string, ociStatus: string) => void;
    saveStatusType: (statustype: string) => void;
    ticketno: string;
    status: string;
    date: string;
    supporttype: string;
    mtype: string;
    messageFiles: File[];
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        mainContainer: {
            padding: '16px !important',
            border: '1px solid #989898',
            borderRadius: '3%'
        },
        avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main,
        },
        form: {
            width: '100%', // Fix IE 11 issue.
            marginTop: theme.spacing(1),
            textAlign: 'center'
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        container: {
            bottom: 0,
            height: '250px',
            overflow: 'auto'
        },
        textField: {
            margin: '0px !important'
        },
        filesDropzoneActive: {
            border: '3px solid #3f51b5',
            color: '#3f51b5',
        },
        fileUpload: {
            textAlign: 'center',
            transition: 'all 1s',
            cursor: 'pointer',
            color: '#ED7D31',
            padding: '12px',
            '&:hover': {
                color: '#3f51b5'
            },
        },
        submit: {
            fontSize: '16px',
            fontWeight: 100,
            textTransform: 'capitalize'
        },
        bubble: {
            display: 'inline-block',
        },
        bubbleReciver: {
            display: 'inline-block',
        },
        right: {
            textAlign: 'right',
            margin: '12px 12px'
        },
        left: {
            textAlign: 'left',
            margin: '12px 12px'
        },
        imageHeight: {
            height: '50px'
        },
        message: {
            fontWeight: 500
        },
        date: {
            fontSize: '12px'
        },
        mfrom: {
            fontWeight: 'bolder',
            color: '#4F93FE'
        },
        mto: {
            fontWeight: 'bolder',
            color: '#38C7D8'
        },
        paper: {
            margin: theme.spacing(1, 5),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        colorDel: {
            color: 'red',
            cursor: 'pointer'
        }
    })
);

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
        },
    },
})(TextField);

const CardHeaderCss = withStyles({
    root: {
        '& .MuiCardHeader-title': {
            // textAlign: 'center',
            fontSize: '25px',
            fontWeight: 500
        },
        '& .MuiCardHeader-action': {
            marginTop: '0px'
        },
        padding: '0 16px'
    },
})(CardHeader);

const SupportPage: React.StatelessComponent<SupportPageprops> = (props) => {
    const classes = useStyles({});
    const inputLab = React.useRef<HTMLLabelElement>(null);
    const [lab, setLab] = React.useState(0);
    React.useEffect(() => {
        setLab(inputLab.current!.offsetWidth);
    });

    const deleteMsgAttach = () => {
        props.onFilesChange([]);
    };

    const chatBubbles = props.getSupportMessage.map((obj, i) => (
        <ScrollToBottom>
            <div>
                {props.customer === obj.mfrom ?
                    <div className={classes.right}>
                        <div key={i++} className={classes.bubble}>
                            <img src="/assets/lab.png" className={classes.imageHeight} />
                            <div className={classes.mfrom}>{obj.mfrom}</div>
                        </div>
                        <div key={i++} className={classes.message}>
                            <div>{obj.message}</div>
                        </div>
                        <div key={i++} className={classes.date}>
                            <div>{obj.mdate}</div>
                        </div>
                        {/* {obj.attachfilename !== '' ?
                            <div onClick={() => props.msgAtt(obj.attachfilename, obj.oci_status)} key={i++} className={classes.date}>
                                <div>{obj.attachfilename.split('/').reverse()[0]}</div>
                            </div>
                            :
                            null
                        } */}
                        {
                            obj.attachfilename !== '' ? (
                                <div className={classes.attachment}>
                                    <Previewform file={obj} />
                                </div>
                            ) :
                                null
                        }
                    </div>
                    : <div className={classes.left}>
                        <div key={i++} className={classes.bubbleReciver}>
                            <img src="/assets/designer.png" className={classes.imageHeight} />
                            <div className={classes.mto}>{obj.mfrom}</div>
                        </div>
                        <div key={i++} className={classes.message}>
                            <div>{obj.message}</div>
                        </div>
                        <div key={i++} className={classes.date}>
                            <div>{obj.mdate}</div>
                        </div>
                        {/* {obj.attachfilename !== '' ?
                            <div onClick={() => props.msgAtt(obj.attachfilename, obj.oci_status)} key={i++} className={classes.date}>
                                <div>{obj.attachfilename.split('/').reverse()[0]}</div>
                            </div>
                            :
                            null
                        } */}
                        {
                            obj.attachfilename !== '' ? (
                                <div className={classes.attachment}>
                                    <Previewform file={obj} />
                                </div>
                            ) :
                                null
                        }
                    </div>
                }
            </div>
        </ScrollToBottom>
    ));
    return (
        <div className={classes.root}>
            <Container component="main" maxWidth="md" className={classes.mainContainer}>
                <CssBaseline />
                <Card variant="outlined">
                    <CardHeaderCss
                        title="Support Ticket Details"
                        avatar={
                            <Avatar aria-label="recipe" className={classes.avatar}>
                                <LiveHelpRoundedIcon />
                            </Avatar>}
                    />
                    <div className={classes.paper}>
                        <form className={classes.form} noValidate>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <CssTextField
                                        size="small"
                                        fullWidth
                                        label="Ticket No"
                                        disabled
                                        value={props.ticketno}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl size="small" variant="outlined" className={classes.forms}>
                                        <InputLabel ref={inputLab} htmlFor="outlined-age-native-simple">
                                            Status
                                        </InputLabel>
                                        <Select
                                            native
                                            onChange={event => props.saveStatusType(event.target.value as string)}
                                            labelWidth={lab}
                                            inputProps={{
                                                name: 'lab',
                                                id: 'outlined-age-native-simple',
                                            }}
                                            defaultValue={props.status}
                                            value={props.status}
                                        >
                                            <option disabled value="" />
                                            {
                                                props.status === '1' || props.status === '2' ?
                                                    <>
                                                        <option value="1">Closed</option>
                                                        <option value="2">Re-Open</option>
                                                    </>
                                                    :
                                                    <>
                                                        <option value="0">Open</option>
                                                        <option value="1">Closed</option>
                                                    </>
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <CssTextField
                                        size="small"
                                        fullWidth
                                        label="Created on"

                                        disabled
                                        value={props.date}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <CssTextField
                                        size="small"
                                        fullWidth
                                        label="Support Type"

                                        disabled
                                        value={props.mtype}
                                    />
                                </Grid>
                            </Grid>
                        </form>
                    </div>
                </Card>
                <ScrollToBottom className={classes.container}>{chatBubbles}</ScrollToBottom>
                <div className={classes.form}>
                    <Grid container>
                        <Grid item xs={10}>
                            <TextField
                                className={classes.textField}
                                // margin="normal"
                                margin="dense"
                                fullWidth
                                autoFocus
                                onChange={event => props.messaging(event.target.value)}
                                label="Write a message..."
                                onKeyPress={event => {
                                    if (event.key === 'Enter' && props.messages !== '') {
                                        props.onSubmit();
                                    }
                                }
                                }
                                value={props.messages}
                            />
                        </Grid>
                        <Grid item xs>
                            <IconButton
                                color="primary"
                                aria-label="add to shopping cart"
                                type="button"
                                disabled={props.messages === ''}
                                onClick={props.onSubmit}
                            >
                                <TelegramIcon fontSize="large" />
                            </IconButton>
                        </Grid>
                        <Grid item xs>
                            <Files
                                className={classes.fileUpload}
                                onChange={props.onFilesChange}
                                onError={props.onFilesError}
                                accepts={['image/*']}
                                multiple={false}
                                maxFiles={1}
                                maxFileSize={10000000}
                                minFileSize={0}
                                dropActiveClassName={classes.filesDropzoneActive}
                                clickable
                            >
                                <PostAddOutlinedIcon fontSize="large" />
                            </Files>
                        </Grid>
                        <Grid container spacing={1} justify="center" alignItems="center">
                                    {
                                        props.messageFiles.length > 0 &&
                                        <div>
                                            Attachment - <strong>{props.messageFiles[props.messageFiles.length - 1].name}</strong>&nbsp;
                                            <IconButton aria-label="delete" onClick={deleteMsgAttach}>
                                                <DeleteIcon className={classes.colorDel} fontSize="large" />
                                            </IconButton>
                                        </div>
                                    }
                                </Grid>
                    </Grid>
                </div>
            </Container>
        </div>
    );
};

export default SupportPage;



// WEBPACK FOOTER //
// ./src/components/layouts/SupportPageView.tsx